import React from 'react';
import { HeartCrackIcon } from 'lucide-react';
const QUIET_THOUGHTS = ['“Mi hijo me dijo una vez, casi sin querer, que sus compañeros traían mejores cosas. Lo dijo sin malicia. Pero yo no lo olvidé.”', '“La lonchera volvió llena otra vez. Y estuve todo el día preguntándome si tuvo hambre. Si pudo concentrarse. Si alguien le preguntó por qué no comía.”', '“Vi una foto en el grupo de WhatsApp de madres. La merienda de otra mamá. Cerré el celular y no dije nada.”', '“Son las 11 de la noche. Recién me acuerdo que mañana es miércoles. Estoy agotada. Pero igual me levanto a ver qué hay.”', '“Mi hijo me preguntó por qué siempre le mando lo mismo. Le dije que era porque era lo que más le gustaba. Pero los dos sabemos que no era verdad.”'];
export function PainAndProduct() {
  return <>
      <section className="bg-white px-4 py-20" data-id="element-95">
        <div className="mx-auto max-w-3xl text-center" data-id="element-96">
          <p className="font-display text-sm font-bold uppercase tracking-[0.16em] text-brand-orange" data-id="element-97">
            El momento que todas conocen
          </p>
          <h2 className="mt-3 font-display text-3xl font-bold text-brand-deep md:text-4xl" data-id="element-98">
            La herida que nadie nombra
          </h2>
          <div className="mt-9 space-y-6 text-lg leading-relaxed text-brand-text md:text-xl" data-id="element-99">
            <p className="font-medium" data-id="element-100">
              Hay un momento que casi todas las mamás uruguayas conocen.
            </p>
            <p data-id="element-101">
              El mate está frío. Los chicos todavía no se levantaron. Y vos ya
              estás parada frente a la heladera con esa pregunta de siempre.
            </p>
            <p className="font-display text-2xl font-bold text-brand-deep md:text-3xl" data-id="element-102">
              “¿Qué le pongo hoy de merienda?”
            </p>
            <p data-id="element-103">
              Agarrás lo mismo de siempre. O comprás algo de camino. O mandás lo
              que quedó de ayer. Pero lo que duele de verdad es lo que viene
              después.
            </p>
          </div>
          <blockquote className="my-11 rounded-2xl border border-brand-sky bg-brand-lightBlue p-7 font-display text-xl font-bold italic leading-relaxed text-brand-deep" data-id="element-104">
            “Mientras tanto · tu hijo está en el colegio. Abre la lonchera. Y
            vuelve a ver lo mismo de siempre.”
          </blockquote>
          <h2 className="font-display text-3xl font-bold text-brand-orange md:text-4xl" data-id="element-105">
            Eso tiene que terminar.
          </h2>
          <p className="mt-6 text-lg leading-relaxed text-brand-text md:text-xl" data-id="element-106">
            No porque la merienda sea lo más importante del mundo. Sino porque
            ya hay un sistema que resuelve esto.
          </p>
          <p className="mt-6 text-lg leading-relaxed text-brand-text md:text-xl" data-id="element-107">
            Alguien ya organizó 60 ideas por situación real. Ya escribió recetas
            simples con ingredientes uruguayos. Ya armó el planificador de 4
            semanas completo. Ya calculó los costos con precios reales de
            Uruguay.
          </p>
          <p className="mt-7 text-lg leading-relaxed text-brand-text md:text-xl" data-id="element-108">
            Y ese trabajo está disponible para vos · ahora mismo · en un PDF que
            descargás hoy y usás mañana.
            <br data-id="element-109" />
            <strong className="text-brand-deep" data-id="element-110">
              Eso es Meriendas que Acompañan.
            </strong>
          </p>
        </div>
      </section>

      <section className="bg-brand-base px-4 py-20" data-id="element-111">
        <div className="mx-auto max-w-5xl" data-id="element-112">
          <header className="mx-auto mb-12 max-w-3xl text-center" data-id="element-113">
            <p className="font-display text-sm font-bold uppercase tracking-[0.16em] text-brand-orange" data-id="element-114">
              Lo que realmente duele
            </p>
            <h2 className="mt-3 font-display text-3xl font-bold text-brand-deep md:text-4xl" data-id="element-115">
              Lo que se dicen solas cuando nadie las escucha
            </h2>
          </header>
          <div className="grid gap-5 md:grid-cols-2" data-id="element-116">
            {QUIET_THOUGHTS.map(thought => <article key={thought} className="flex gap-4 rounded-2xl border border-rose-100 bg-white p-6 shadow-sm" data-id="element-117">
                <HeartCrackIcon className="mt-1 h-6 w-6 shrink-0 text-rose-400" data-id="element-118" />
                <p className="font-medium leading-relaxed text-brand-text" data-id="element-119">
                  {thought}
                </p>
              </article>)}
          </div>
          <div className="mx-auto mt-12 max-w-2xl text-center" data-id="element-120">
            <p className="font-display text-2xl font-bold text-brand-deep md:text-3xl" data-id="element-121">
              “¿Soy buena madre si no puedo resolver algo tan simple?”
            </p>
            <p className="mt-5 text-lg font-medium leading-relaxed text-brand-text" data-id="element-122">
              Esa pregunta tiene que dejar de existir. Y este kit existe
              exactamente para eso.
            </p>
          </div>
        </div>
      </section>

      <section className="bg-white px-4 py-20" data-id="element-123">
        <div className="mx-auto max-w-3xl text-center" data-id="element-124">
          <h2 className="font-display text-3xl font-bold text-brand-deep md:text-4xl" data-id="element-125">
            No es que no hayas intentado resolver esto.
          </h2>
          <div className="mt-8 space-y-6 text-lg leading-relaxed text-brand-text" data-id="element-126">
            <p data-id="element-127">
              Lo intentaste con cuentas de Instagram de loncheras hermosas. Las
              miraste, te inspiraste, y el lunes a las 7 no pudo replicarse
              ninguna.
            </p>
            <p data-id="element-128">
              Lo intentaste con PDFs gratuitos de recetas saludables. Pasaste
              más tiempo filtrando lo que no era de Uruguay que usando lo que sí
              servía.
            </p>
            <p data-id="element-129">
              Lo intentaste armando tu propio sistema. Funcionó dos semanas.
              Después vino una semana complicada y se desarmó todo.
            </p>
          </div>
          <div className="mt-12 rounded-3xl bg-brand-deep p-8 text-left text-white shadow-xl md:p-10" data-id="element-130">
            <p className="text-xl font-medium text-brand-sky" data-id="element-131">
              El problema no es tu dedicación.
              <br data-id="element-132" />
              El problema no es tu amor por tus hijos.
            </p>
            <p className="mt-6 text-xl font-bold leading-relaxed md:text-2xl" data-id="element-133">
              El problema es que nunca tuviste un sistema completo · listo ·
              adaptado a la realidad uruguaya · con todo integrado.
            </p>
            <p className="mt-8 font-display text-3xl font-bold text-brand-orange" data-id="element-134">
              Hasta hoy.
            </p>
          </div>
        </div>
      </section>

      <section className="relative overflow-hidden bg-brand-deep px-4 py-20 text-center text-white" data-id="element-135">
        <div className="relative mx-auto max-w-4xl" data-id="element-136">
          <span className="inline-flex rounded-full border border-white/20 bg-white/10 px-5 py-2 text-sm font-bold" data-id="element-137">
            🏆 El sistema que eligen las familias uruguayas
          </span>
          <p className="mt-8 text-sm font-bold uppercase tracking-[0.18em] text-brand-orange" data-id="element-138">
            🐦‍🔥 Tu Fénix Digital
          </p>
          <h2 className="mt-3 font-display text-4xl font-bold md:text-6xl" data-id="element-139">
            MERIENDAS QUE <span className="text-brand-orange" data-id="element-140">ACOMPAÑAN</span>
          </h2>
          <p className="mx-auto mt-6 max-w-2xl text-xl font-medium leading-relaxed text-brand-sky md:text-2xl" data-id="element-141">
            El sistema de planificación de meriendas escolares más completo para
            familias uruguayas.
          </p>
          <p className="mt-5 text-lg text-slate-300" data-id="element-142">
            100% PDF. Acceso inmediato. Adaptado al presupuesto y al tiempo de
            las familias uruguayas 2026.
          </p>
        </div>
      </section>
    </>;
}